/**
 * @type {import('./').IApiService}
 */
import { throwGlobal } from '@goodt-wcore/errors';
import { BaseApiServiceBase } from './BaseApiServiceBase';

export class BaseApiService extends BaseApiServiceBase {
    /**
     * If throw api service error
     *
     * @type {boolean}
     * @protected
     */
    _globalError = true;

    /**
     * @inheritDoc
     */
    setOptions(options) {
        const { globalError, ...serviceOptions } = options;
        if (globalError != null) {
            this._globalError = globalError;
        }

        super.setOptions(serviceOptions);
    }

    /**
     * @param {import('../types').IApiServiceRequest} request
     * @return {Promise<import('@goodt-common/utils').ISafeResult<*, Error>>}
     */
    request(request) {
        return super.request(request).then((safeResult) => {
            const { isError, error } = safeResult;
            if (isError) {
                const shouldThrowGlobal =
                    request.options?.globalError === true ||
                    (request.options?.globalError == null && this._globalError === true);

                if (shouldThrowGlobal) {
                    throwGlobal(error, { context: this.request });
                }
            }

            return safeResult;
        });
    }
}

export { BaseApiService as default };
